import styled from "@emotion/styled";
import React from "react";
import { match } from "ts-pattern";
import { ComplianceCardData } from "../../../utils/complianceUtils";
import { doNothing } from "../../../utils/doNothing";
import {
  ALERT_ICON_OUTLINE,
  CHECK_ICON,
  CLOCK_ICON,
  HOURGLASS_ICON,
} from "../../../utils/svgs_new";
import CircleIcon from "../../CircleIcon";
import NextButton from "../../NextButton/NextButton";
import { CircleShimmer, TextShimmer } from "../../Shimmer";

type Props =
  | {
      isLoading: true;
    }
  | (ComplianceCardData & {
      isLoading: false;
      onClick: () => void;
    });

function ComplianceUploadCard(props: Props) {
  const color = props.isLoading
    ? "transparent"
    : match(props.type)
        .with("issue", () => "var(--red)")
        .with("expiresSoon", () => "var(--orange)")
        .with("dueSoon", () => "var(--orange)")
        .with("compliant", () => "var(--green)")
        .with("pending", () => "var(--orange)")
        .exhaustive();

  if (props.isLoading) {
    return (
      <ComplianceUploadCard.Styled onClick={doNothing}>
        <CircleIcon.Wrapper color={color}>
          <CircleShimmer width={40} height={40} />
        </CircleIcon.Wrapper>
        <ComplianceUploadCard.ContentWrapper>
          <ComplianceUploadCard.Title>
            <TextShimmer width={40} height={16} />
          </ComplianceUploadCard.Title>
          <ComplianceUploadCard.Subtitle>
            <TextShimmer width={90} height={14} />
          </ComplianceUploadCard.Subtitle>
        </ComplianceUploadCard.ContentWrapper>
        <NextButton />
      </ComplianceUploadCard.Styled>
    );
  }

  const icon = match(props.type)
    .with("issue", () => ALERT_ICON_OUTLINE)
    .with("expiresSoon", () => HOURGLASS_ICON)
    .with("dueSoon", () => HOURGLASS_ICON)
    .with("compliant", () => CHECK_ICON)
    .with("pending", () => CLOCK_ICON)
    .exhaustive();

  return (
    <ComplianceUploadCard.Styled onClick={props.onClick}>
      <CircleIcon color="white" icon={icon} fill={color} stroke={color} />
      <ComplianceUploadCard.ContentWrapper>
        <ComplianceUploadCard.Title>{props.item.documentType.name}</ComplianceUploadCard.Title>
        <ComplianceUploadCard.Subtitle>{props.subTitle}</ComplianceUploadCard.Subtitle>
      </ComplianceUploadCard.ContentWrapper>
      <NextButton />
    </ComplianceUploadCard.Styled>
  );
}

ComplianceUploadCard.ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

ComplianceUploadCard.Title = styled.span`
  font-size: 16px;
`;

ComplianceUploadCard.Subtitle = styled.span`
  color: var(--gray-500);
  font-size: 14px;
`;

ComplianceUploadCard.Styled = styled.div`
  .AppCardContent {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  ${NextButton.Styled} {
    flex-shrink: 0;
  }

  ${ComplianceUploadCard.ContentWrapper} {
    flex: 1;
  }
`;

export default ComplianceUploadCard;
